import type { TicketBlueprintAttributes as GQLInput } from '../../../generated/api.graphql';
import { take } from '../../../util';
import type { TicketBlueprintKind } from './TicketBlueprintKind';
import type { TicketSaleTrigger } from './TicketSaleTrigger';
import type { TicketSellableThrough } from './TicketSellableThrough';

/** What a caller hands `toGqlInput`. No `id` creates, an `id` updates. */
export type TicketBlueprintInput = {
  id?: number | null;
  eventId: number;
  name?: string | null;
  description?: string | null;
  kind?: TicketBlueprintKind | null;
  price?: number | null;
  fee?: number | null;
  saleTrigger?: TicketSaleTrigger | null;
  sellStart?: string | null;
  sellEnd?: string | null;
  dependencyId?: number | null;
  sellableThrough?: TicketSellableThrough[] | null;
  allotment?: number | null;
  sectionId?: number | null;
  minimum?: number | null;
  maximum?: number | null;
  multiple?: number | null;
  discountIds?: number[] | null;
};

const GQL_FIELDS = [
  'allotment', 'dependencyId', 'description', 'discountIds', 'eventId', 'fee', 'id', 'kind', 'maximum', 'minimum', 'multiple', 'name', 'price', 'saleTrigger', 'sectionId',
  'sellableThrough', 'sellEnd', 'sellStart',
] as const;

/** Drops what the mutation rejects, and the keys a caller left undefined so the server never sees them. */
export const toGqlInput = (input: TicketBlueprintInput): GQLInput =>
  take<GQLInput, TicketBlueprintInput>(input, ...GQL_FIELDS);
